import axios from 'axios';
import type { QueryParamsInterface } from '../types/Shared';
import type { User } from '../types/User';
import { baseUrl, HttpMethods } from './base';

interface IGetUsersService {
  params?: QueryParamsInterface;
}

export interface IGetUsersServiceParams {
  name: string;
  email: string;
  title_id: string;
  active: string;
}

export interface IGetUsersServiceRes {
  data: User[];
  meta: { total: number };
}

export interface UserDetail extends User {
  titleId: number;
  roleId: string;
}

export interface UserDetailResponse {
  data: UserDetail;
}

export interface UpdateUserPayload {
  active?: boolean;
  email?: string;
  name?: string;
  titleId?: number;
}

export const userQueryKeys = {
  all: ['GET_USERS'] as const,
  lists: () => ['GET_USERS', 'list'] as const,
  list: (params?: QueryParamsInterface) => ['GET_USERS', 'list', params] as const,
  detail: (userId: number) => ['GET_USERS', 'detail', userId] as const,
};

export async function getUsers({ params }: IGetUsersService): Promise<IGetUsersServiceRes> {
  const resp = await axios.request<IGetUsersServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.TERMINAL}/user-management/users/list`,
    params,
  });
  return resp.data;
}

export interface IPostUserInviteServicePayload {
  name: string;
  email: string;
  titleId: number;
}

export async function sendInvite(formData: IPostUserInviteServicePayload) {
  const resp = await axios.post(`${baseUrl.TERMINAL}/user-management/users/invite`, formData);
  return resp.data;
}

export async function postForgotPassword(data: { email: string }) {
  const resp = await axios({
    method: HttpMethods.POST,
    url: `${baseUrl.SHARED}/auth/users/forgot_password`,
    data,
  });
  return resp;
}

export async function resetPassword(data: { password: string; passwordConfirmation: string; token: string }) {
  const resp = await axios.patch(`${baseUrl.SHARED}/auth/users/reset_password`, data);
  return resp.data;
}

export async function userOnboard(data: { tempPassword: string; password: string; passwordConfirmation: string; token: string }) {
  const response = await axios.post(`${baseUrl.TERMINAL}/user-management/users/invite/confirm`, data);
  return response;
}

export async function postReInviteUser(userId: number) {
  const response = await axios.post(`${baseUrl.TERMINAL}/user-management/users/${userId}/reinvite`);
  return response.data;
}

export async function deleteUser(userId: number) {
  const response = await axios.delete(`${baseUrl.TERMINAL}/user-management/users/${userId}`);
  return response;
}

export async function getUser(userId: number): Promise<UserDetailResponse> {
  const response = await axios.get<UserDetailResponse>(`${baseUrl.TERMINAL}/user-management/users/${userId}`);
  return response.data;
}

export async function updateUser(id: number, data: UpdateUserPayload) {
  const response = await axios.patch(`${baseUrl.TERMINAL}/user-management/users/${id}`, data);
  return response;
}
